import { render, staticRenderFns } from "./KPIRating.vue?vue&type=template&id=634451b7"
import script from "./KPIRating.vue?vue&type=script&lang=js"
export * from "./KPIRating.vue?vue&type=script&lang=js"
import style0 from "./KPIRating.vue?vue&type=style&index=0&id=634451b7&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports